import { connect } from 'react-redux'
import DesktopNavigation from '../../Components/Navigation/Desktop'

const DesktopNavigationContainer = DesktopNavigation

const mapStateToProps = (state) => {
    return {
        links: state.navigation.contentLinks,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DesktopNavigationContainer)
